/* GoShopCara Market (Shopify) — front-end behaviour, no dependencies. */
(function () {
	'use strict';

	var C = window.GSC || {};
	var T = C.i18n || {};
	var $ = function (s, r) { return (r || document).querySelector(s); };
	var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
	var store = {
		get: function (k, d) { try { var v = localStorage.getItem(k); return v === null ? d : JSON.parse(v); } catch (e) { return d; } },
		set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* private mode */ } }
	};
	function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
	function debounce(fn, ms) { var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); }; }
	function money(cents) {
		var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		return (C.money || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, v.split('.')[0]);
	}
	var ICON = {
		heart: '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20.3s-7.5-4.6-9.2-9.4C1.6 7.4 3.8 4 7.3 4c2 0 3.6 1.1 4.7 2.7C13.1 5.1 14.7 4 16.7 4c3.5 0 5.7 3.4 4.5 6.9-1.7 4.8-9.2 9.4-9.2 9.4z"/></svg>',
		plus: '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
		minus: '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>',
		check: '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>'
	};

	/* ------------------------------------------------ exact brand search */
	var brandGrid = $('[data-gc-brand-grid]');
	if (brandGrid) {
		var brandKey = String(brandGrid.getAttribute('data-brand-key') || '').trim().toLowerCase();
		var brandIndex = window.GSC_BRAND_INDEX || {};
		var brandHandles = brandIndex[brandKey] || [];
		var brandPageSize = 30;
		var brandLoading = $('[data-gc-brand-loading]');
		var brandPager = $('[data-gc-brand-pager]');
		var brandCount = $('[data-gc-brand-count]');
		if (brandCount) { brandCount.textContent = '(' + brandHandles.length + ' ' + (brandHandles.length === 1 ? 'result' : 'results') + ')'; }

		function brandPageFromHash() {
			var match = String(window.location.hash || '').match(/^#brand-page=(\d+)$/);
			var page = match ? parseInt(match[1], 10) : 1;
			var max = Math.max(1, Math.ceil(brandHandles.length / brandPageSize));
			return Math.max(1, Math.min(page || 1, max));
		}

		function paintBrandPager(page) {
			if (!brandPager) { return; }
			var pages = Math.ceil(brandHandles.length / brandPageSize);
			if (pages < 2) { brandPager.hidden = true; return; }
			var html = '';
			if (page > 1) { html += '<a class="page-numbers prev" href="#brand-page=' + (page - 1) + '" aria-label="Previous page">&larr;</a>'; }
			for (var n = 1; n <= pages; n += 1) {
				if (n === page) {
					html += '<span class="page-numbers current" aria-current="page">' + n + '</span>';
				} else if (n === 1 || n === pages || Math.abs(n - page) <= 2) {
					html += '<a class="page-numbers" href="#brand-page=' + n + '">' + n + '</a>';
				} else if (n === page - 3 || n === page + 3) {
					html += '<span class="page-numbers dots">&hellip;</span>';
				}
			}
			if (page < pages) { html += '<a class="page-numbers next" href="#brand-page=' + (page + 1) + '" aria-label="Next page">&rarr;</a>'; }
			brandPager.innerHTML = html;
			brandPager.hidden = false;
		}

		function brandCard(p) {
			var img = p.featured_image || (p.images && p.images[0]) || '';
			if (img) { img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=600'; }
			var v = p.variants && p.variants[0];
			var compare = Number(p.compare_at_price || 0);
			var price = Number(p.price || 0);
			var badge = compare > price ? '<span class="pc__badge">Sale</span>' : '';
			var priceHtml = compare > price ? '<ins>' + esc(money(price)) + '</ins> <del>' + esc(money(compare)) + '</del>' : esc(money(price));
			var add = p.available && v && p.variants.length === 1 ? '<button class="pc__add" type="button" data-add="' + v.id + '">' + ICON.plus + '<span>' + esc(T.addToCart) + '</span></button>' : '';
			return '<article class="pc" data-id="' + esc(p.id) + '"><div class="pc__media"><a class="pc__link" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
				(img ? '<img class="pc__img" src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' + badge +
				'<button class="fav-btn" type="button" data-fav="' + esc(p.handle) + '" aria-pressed="false" aria-label="Save ' + esc(p.title) + ' to Favorites">' + ICON.heart + '</button>' + add +
				'</div><div class="pc__body"><h3 class="pc__title"><a href="' + esc(p.url) + '" title="' + esc(p.title) + '">' + esc(p.title) + '</a></h3>' +
				'<p class="pc__meta"><span class="pc__brand">' + esc(p.vendor) + '</span></p><p class="pc__price">' + priceHtml + '</p>' +
				(p.available ? '' : '<span class="pill pill--muted">Sold out</span>') + '</div></article>';
		}

		function renderBrandPage(scrollToResults) {
			var page = brandPageFromHash();
			var start = (page - 1) * brandPageSize;
			var handles = brandHandles.slice(start, start + brandPageSize);
			brandGrid.innerHTML = '';
			if (brandLoading) { brandLoading.hidden = false; brandLoading.textContent = 'Loading watches…'; }
			paintBrandPager(page);
			Promise.all(handles.map(function (handle) {
				return fetch((C.root || '/') + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
					.then(function (response) { return response.ok ? response.json() : null; })
					.catch(function () { return null; });
			})).then(function (products) {
				var html = products.filter(Boolean).map(brandCard).join('');
				brandGrid.innerHTML = html;
				if (brandLoading) {
					brandLoading.hidden = !!html;
					if (!html) { brandLoading.textContent = 'No matching watches are available.'; }
				}
				paintFavs();
				if (scrollToResults) { brandGrid.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
			});
		}

		window.addEventListener('hashchange', function () { renderBrandPage(true); });
		renderBrandPage(false);
	}

	/* ------------------------------------------------------------ toast */
	var toastEl = $('.toast'), toastTimer;
	function toast(html, ms) {
		if (!toastEl) { return; }
		toastEl.innerHTML = html;
		toastEl.hidden = false;
		toastEl.style.animation = 'none'; void toastEl.offsetWidth; toastEl.style.animation = '';
		clearTimeout(toastTimer);
		toastTimer = setTimeout(function () { toastEl.hidden = true; }, ms || 4200);
	}

	/* ------------------------------------------------------------ header */
	var hdr = $('[data-hdr]');
	if (hdr) {
		var onScroll = function () { hdr.classList.toggle('is-stuck', window.scrollY > 40); };
		window.addEventListener('scroll', onScroll, { passive: true });
		onScroll();
	}
	var catsBtn = $('[data-cats]'), catsPanel = $('#cats-panel');
	function closeCats() { if (catsPanel && !catsPanel.hidden) { catsPanel.hidden = true; catsBtn.setAttribute('aria-expanded', 'false'); } }
	if (catsBtn && catsPanel) {
		catsBtn.addEventListener('click', function (e) {
			e.stopPropagation();
			var open = catsPanel.hidden;
			catsPanel.hidden = !open;
			catsBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
		});
		document.addEventListener('click', function (e) { if (!catsPanel.contains(e.target)) { closeCats(); } });
	}
	function modal(el, open, opener) {
		if (!el) { return; }
		el.hidden = !open;
		document.documentElement.style.overflow = open ? 'hidden' : '';
		if (open) {
			el._opener = opener || document.activeElement;
			var f = el.querySelector('button, a, input');
			if (f) { setTimeout(function () { f.focus(); }, 30); }
		} else if (el._opener && el._opener.focus) {
			el._opener.focus();
		}
	}
	var drawer = $('#drawer'), filters = $('#filters');
	$$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { modal(drawer, true, b); }); });
	$$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { modal(drawer, false); }); });
	$$('[data-filters-open]').forEach(function (b) { b.addEventListener('click', function () { modal(filters, true, b); }); });
	$$('[data-filters-close]').forEach(function (b) { b.addEventListener('click', function () { modal(filters, false); }); });

	var lb = $('[data-lightbox]'), lbImg = lb && $('.lightbox__img', lb), lbIdx = 0;
	var gal = $('[data-gallery]');
	var slides = gal ? $$('.gal__slide', gal) : [];
	function closeLightbox() { if (lb && !lb.hidden) { lb.hidden = true; document.documentElement.style.overflow = ''; } }

	document.addEventListener('keydown', function (e) {
		if (e.key !== 'Escape') { return; }
		closeCats();
		if (drawer && !drawer.hidden) { modal(drawer, false); }
		if (filters && !filters.hidden) { modal(filters, false); }
		closeLightbox();
		$$('.search__suggest').forEach(function (s) { s.hidden = true; });
	});

	/* ------------------------------------------------------------ search */
	$$('form[data-suggest]').forEach(function (form) {
		var input = $('.search__input', form), box = $('.search__suggest', form), idx = -1, last = '';
		if (!input || !box) { return; }
		var run = debounce(function () {
			var q = input.value.trim();
			if (q.length < 2) { box.hidden = true; return; }
			if (q === last) { box.hidden = false; return; }
			last = q;
			fetch((C.searchUrl || '/search') + '/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
				.then(function (r) { return r.json(); })
				.then(function (res) {
					if (input.value.trim() !== q) { return; }
					var items = (res && res.resources && res.resources.results && res.resources.results.products) || [];
					var all = (C.searchUrl || '/search') + '?type=product&q=' + encodeURIComponent(q);
					var html = items.length ? items.map(function (it) {
						var img = it.featured_image && it.featured_image.url ? it.featured_image.url : it.image;
						if (img) { img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=100'; }
						var price = it.price ? money(Math.round(parseFloat(it.price) * 100)) : '';
						return '<a class="sugg" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="44" height="44">' : '') + '<span class="sugg__name">' + esc(it.title) + '</span><span class="sugg__price">' + esc(price) + '</span></a>';
					}).join('') : '<p class="sugg__empty">' + esc(T.noResults) + '</p>';
					html += '<a class="sugg sugg--all" href="' + esc(all) + '">' + esc(T.seeAll) + ' “' + esc(q) + '”</a>';
					box.innerHTML = html;
					box.hidden = false;
					idx = -1;
				})
				.catch(function () { box.hidden = true; });
		}, 220);
		input.addEventListener('input', run);
		input.addEventListener('focus', function () { if (box.innerHTML && input.value.trim().length > 1) { box.hidden = false; } });
		input.addEventListener('keydown', function (e) {
			var links = $$('.sugg', box);
			if (box.hidden || !links.length) { return; }
			if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
				e.preventDefault();
				idx = (idx + (e.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
				links.forEach(function (l, i) { l.classList.toggle('is-active', i === idx); });
			} else if (e.key === 'Enter' && idx > -1) {
				e.preventDefault();
				window.location = links[idx].href;
			}
		});
		document.addEventListener('click', function (e) { if (!form.contains(e.target)) { box.hidden = true; } });
	});

	/* --------------------------------------------------------- favorites */
	var FAV_KEY = 'gsc_favs_h';
	function favs() { var f = store.get(FAV_KEY, []); return Array.isArray(f) ? f.filter(function (h) { return typeof h === 'string' && h; }) : []; }
	function paintFavs() {
		var list = favs();
		$$('[data-fav]').forEach(function (b) { b.setAttribute('aria-pressed', list.indexOf(b.getAttribute('data-fav')) > -1 ? 'true' : 'false'); });
		$$('.fav-count').forEach(function (c) { c.textContent = list.length; c.hidden = !list.length; });
	}
	function favEmpty() {
		var grid = $('[data-fav-grid]'), empty = $('[data-fav-empty]');
		if (grid && empty) { empty.hidden = grid.children.length > 0; }
	}
	document.addEventListener('click', function (e) {
		var b = e.target.closest('[data-fav]');
		if (!b) { return; }
		e.preventDefault();
		var h = b.getAttribute('data-fav'), list = favs(), at = list.indexOf(h);
		if (at > -1) { list.splice(at, 1); } else { list.unshift(h); }
		store.set(FAV_KEY, list.slice(0, 100));
		paintFavs();
		b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop');
		toast(ICON.heart + '<span>' + esc(at > -1 ? T.favRemove : T.favAdd) + '</span>' + (at > -1 ? '' : '<a href="' + esc(C.favUrl) + '">View</a>'), 2600);
		var grid = $('[data-fav-grid]');
		if (at > -1 && grid && grid.contains(b)) { var card = b.closest('.pc'); if (card) { card.remove(); } favEmpty(); }
	});
	paintFavs();
	window.addEventListener('storage', function (e) { if (e.key === FAV_KEY) { paintFavs(); } });

	var favGrid = $('[data-fav-grid]');
	if (favGrid) {
		var hs = favs();
		if (!hs.length) { favEmpty(); } else {
			Promise.all(hs.map(function (h) {
				return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
			})).then(function (rows) {
				favGrid.innerHTML = rows.filter(Boolean).map(function (p) {
					var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
					var v = p.variants && p.variants[0];
					var free = C.freeShip && p.price >= C.freeShip * 100;
					return '<article class="pc"><div class="pc__media"><a class="pc__link" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (img ? '<img class="pc__img" src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
						'<button class="fav-btn" type="button" data-fav="' + esc(p.handle) + '" aria-pressed="true" aria-label="Remove from Favorites">' + ICON.heart + '</button>' +
						(p.available && v && p.variants.length === 1 ? '<button class="pc__add" type="button" data-add="' + v.id + '">' + ICON.plus + '<span>' + esc(T.addToCart) + '</span></button>' : '') +
						'</div><div class="pc__body"><h3 class="pc__title"><a href="' + esc(p.url) + '" title="' + esc(p.title) + '">' + esc(p.title) + '</a></h3>' +
						'<p class="pc__meta"><span class="pc__brand">' + esc(p.vendor) + '</span></p><p class="pc__price">' + esc(money(p.price)) + '</p>' +
						(free ? '<span class="pill pill--ship">' + esc(T.freeShip) + '</span>' : '') + '</div></article>';
				}).join('');
				paintFavs();
				favEmpty();
			});
		}
	}

	/* -------------------------------------------------------- add to cart */
	function refreshCount() {
		return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
			$$('.cart-count').forEach(function (el) { el.textContent = c.item_count; el.hidden = !c.item_count; });
			return c;
		}).catch(function () { /* ignore */ });
	}
	function addToCart(id, qty, img, addonIds) {
		var amount = +qty || 1;
		var items = [{ id: +id, quantity: amount }];
		(addonIds || []).forEach(function (addonId) {
			addonId = +addonId;
			if (addonId) { items.push({ id: addonId, quantity: amount }); }
		});
		return fetch('/cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
			body: JSON.stringify({ items: items })
		}).then(function (r) {
			return r.json().then(function (j) { if (!r.ok) { var e = new Error('cart'); e.msg = j && (j.description || j.message); throw e; } return j; });
		}).then(function (res) {
			refreshCount();
			toast((img ? '<img src="' + esc(img) + '" alt="">' : ICON.check) + '<span>' + esc(T.added) + '</span><a href="' + esc(C.cartUrl || '/cart') + '">' + esc(T.viewCart) + '</a>', 5200);
			return res;
		});
	}
	document.addEventListener('click', function (e) {
		var b = e.target.closest('[data-add]');
		if (!b) { return; }
		e.preventDefault();
		var card = b.closest('.pc'), img = card && $('.pc__img', card);
		b.classList.add('is-busy');
		addToCart(b.getAttribute('data-add'), 1, img && (img.currentSrc || img.src))
			.catch(function (err) { toast('<span>' + esc((err && err.msg) || T.error) + '</span>'); })
			.then(function () { b.classList.remove('is-busy'); });
	});

	/* ------------------------------------------------------- qty steppers */
	function steppers(root) {
		$$('.quantity', root).forEach(function (q) {
			var input = $('input.qty', q);
			if (!input || q.dataset.step) { return; }
			q.dataset.step = '1';
			var minus = document.createElement('button'), plus = document.createElement('button');
			minus.type = plus.type = 'button';
			minus.className = plus.className = 'qty-step';
			minus.innerHTML = ICON.minus; plus.innerHTML = ICON.plus;
			minus.setAttribute('aria-label', 'Decrease quantity');
			plus.setAttribute('aria-label', 'Increase quantity');
			q.insertBefore(minus, input);
			q.appendChild(plus);
			function bump(d) {
				var min = parseFloat(input.min) || 0, max = parseFloat(input.max) || Infinity;
				input.value = Math.min(max, Math.max(min, (parseFloat(input.value) || 0) + d));
				input.dispatchEvent(new Event('change', { bubbles: true }));
			}
			minus.addEventListener('click', function () { bump(-1); });
			plus.addEventListener('click', function () { bump(1); });
		});
	}
	steppers(document);

	/* -------------------------------------------------------------- cart */
	var cartForm = $('[data-cart-form]');
	if (cartForm) {
		var submitCart = debounce(function () { cartForm.submit(); }, 700);
		cartForm.addEventListener('change', function (e) { if (e.target.matches('input.qty')) { submitCart(); } });
		var cApply = $('[data-coupon-apply]'), cInput = $('[data-coupon]');
		if (cApply && cInput) {
			var go = function () { var code = cInput.value.trim(); if (code) { window.location = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart'); } };
			cApply.addEventListener('click', go);
			cInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });
		}
	}

	/* --------------------------------------------------------- collection */
	var sortSel = $('[data-sort]');
	if (sortSel) {
		sortSel.addEventListener('change', function () {
			var u = new URL(window.location.href);
			u.searchParams.set('sort_by', sortSel.value);
			u.searchParams.delete('page');
			window.location = u.toString();
		});
	}

	/* ----------------------------------------------------------- listing */
	// Start loading a gallery photo now instead of waiting until it scrolls into view.
	function warmSlide(i) {
		var s = slides[(i + slides.length) % slides.length], im = s && $('img', s);
		if (im && im.getAttribute('loading') === 'lazy') { im.setAttribute('loading', 'eager'); }
	}
	function preloadFull(i) {
		var s = slides[(i + slides.length) % slides.length], src = s && s.getAttribute('data-full');
		if (src) { (new Image()).src = src; }
	}
	function showLb(i) {
		if (!lb || !slides.length) { return; }
		lbIdx = (i + slides.length) % slides.length;
		var idx = lbIdx, full = slides[idx].getAttribute('data-full'), small = $('img', slides[idx]);
		lbImg.alt = (small || {}).alt || '';
		// Show the photo already on the page straight away, then swap in the full-size file once it has loaded.
		if (small && small.complete && small.naturalWidth) {
			lbImg.src = small.currentSrc || small.src;
			var big = new Image();
			big.onload = function () { if (lbIdx === idx && !lb.hidden) { lbImg.src = full; } };
			big.src = full;
		} else {
			lbImg.src = full;
		}
		lb.hidden = false;
		document.documentElement.style.overflow = 'hidden';
		preloadFull(idx + 1);
		preloadFull(idx - 1);
	}
	if (gal) {
		var track = $('.gal__track', gal), thumbs = $$('.gal__thumb', gal), count = $('.gal__count b', gal), cur = 0, ticking = false;
		// Switch photos instantly. Smooth scrolling slid through every photo in between,
		// and the thumbnail and counter only updated once that animation had finished.
		track.style.scrollBehavior = 'auto';
		var mark = function (i) {
			cur = i;
			thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === i); t.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
			if (count) { count.textContent = i + 1; }
			warmSlide(i + 1);
			warmSlide(i - 1);
			if (thumbs[i]) {
				var rail = thumbs[i].parentNode;
				if (rail.scrollHeight > rail.clientHeight) { rail.scrollTo({ top: thumbs[i].offsetTop - rail.clientHeight / 2 + 32, behavior: 'smooth' }); }
				if (rail.scrollWidth > rail.clientWidth) { rail.scrollTo({ left: thumbs[i].offsetLeft - rail.clientWidth / 2 + 28, behavior: 'smooth' }); }
			}
		};
		var go = function (i) {
			if (!slides.length) { return; }
			var n = (i + slides.length) % slides.length;
			warmSlide(n);
			track.scrollLeft = track.clientWidth * n;
			if (n !== cur) { mark(n); }
		};
		thumbs.forEach(function (t) {
			var n = +t.getAttribute('data-go');
			t.addEventListener('click', function () { go(n); });
			t.addEventListener('pointerenter', function () { warmSlide(n); });
		});
		$$('[data-step]', gal).forEach(function (b) {
			var step = +b.getAttribute('data-step');
			b.addEventListener('click', function () { go(cur + step); });
			b.addEventListener('pointerenter', function () { warmSlide(cur + step); });
		});
		// Keep the thumbnail and counter in step while the shopper swipes.
		track.addEventListener('scroll', function () {
			if (ticking) { return; }
			ticking = true;
			requestAnimationFrame(function () {
				ticking = false;
				var n = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
				if (n !== cur && slides[n]) { mark(n); }
			});
		}, { passive: true });
		track.addEventListener('keydown', function (e) {
			if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
			if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
		});
		slides.forEach(function (s, i) { s.addEventListener('click', function () { showLb(i); }); });
		var zoom = $('[data-zoom]', gal);
		if (zoom) { zoom.addEventListener('click', function () { showLb(cur); }); }
		window.addEventListener('resize', debounce(function () { track.scrollLeft = track.clientWidth * cur; }, 120));
		// Once the page has finished loading, fetch the remaining photos in the background.
		var warmAll = function () { slides.forEach(function (s, i) { warmSlide(i); }); };
		if (document.readyState === 'complete') { warmAll(); } else { window.addEventListener('load', warmAll); }
	}
	if (lb) {
		$$('[data-lb-step]', lb).forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); showLb(lbIdx + (+b.getAttribute('data-lb-step'))); }); });
		$('[data-lightbox-close]', lb).addEventListener('click', closeLightbox);
		lb.addEventListener('click', function (e) { if (e.target === lb) { closeLightbox(); } });
		document.addEventListener('keydown', function (e) {
			if (lb.hidden) { return; }
			if (e.key === 'ArrowRight') { showLb(lbIdx + 1); }
			if (e.key === 'ArrowLeft') { showLb(lbIdx - 1); }
		});
	}

	var form = $('form[data-gc-form]');
	if (form) {
		form.addEventListener('submit', function (e) {
			var sub = e.submitter;
			var isAdd = sub && sub.name === 'add';
			var isBuyNow = sub && sub.name === 'return_to';
			if (!isAdd && !isBuyNow) { return; }
			var addonIds = $$('[data-addon-variant]:checked', form).map(function (input) { return input.getAttribute('data-addon-variant'); }).filter(Boolean);
			// With no add-ons selected, keep Shopify's native accelerated "Buy it now" flow.
			if (isBuyNow && !addonIds.length) { return; }
			e.preventDefault();
			var id = (form.querySelector('[name="id"]') || {}).value, qty = (form.querySelector('[name="quantity"]') || {}).value;
			var first = $('.gal__slide img');
			sub.classList.add('is-busy');
			addToCart(id, qty, first && (first.currentSrc || first.src), addonIds)
				.then(function () { if (isBuyNow) { window.location.href = '/checkout'; } })
				.catch(function (err) {
					if (addonIds.length) {
						toast('<span>' + esc((err && err.msg) || 'Could not add the selected add-ons. Check that the add-on products are available.') + '</span>', 6200);
					} else {
						form.submit();
					}
				})
				.then(function () { sub.classList.remove('is-busy'); });
		});
		var bar = $('[data-buybar]');
		if (bar) {
			var sync = function () {
				var r = form.getBoundingClientRect();
				var show = r.bottom < 0 && window.innerWidth <= 900;
				bar.hidden = !show;
				document.body.classList.toggle('has-buybar', show);
			};
			window.addEventListener('scroll', sync, { passive: true });
			sync();
			var barBtn = $('[data-buybar-add]', bar);
			if (barBtn) { barBtn.addEventListener('click', function () { var btn = form.querySelector('[name="add"]'); if (btn) { btn.click(); } }); }
		}
	}

	// Arrival windows in business days (preparation + transit), set per service in data-min / data-max.
	var arrive = $$('[data-arrive]');
	if (arrive.length) {
		var addBiz = function (n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) { n--; } } return d; };
		var mon = function (d) { return d.toLocaleDateString('en-US', { month: 'short' }); };
		arrive.forEach(function (el) {
			var lo = parseInt(el.getAttribute('data-min'), 10), hi = parseInt(el.getAttribute('data-max'), 10);
			if (!lo || !hi) { return; }
			var a = addBiz(lo), b = addBiz(hi);
			el.textContent = mon(a) + ' ' + a.getDate() + '–' + (mon(a) === mon(b) ? '' : mon(b) + ' ') + b.getDate();
		});
	}

	$$('[data-clamp]').forEach(function (c) {
		var body = $('.clamp__body', c), more = $('.clamp__more', c);
		if (!body || !more) { return; }
		var check = function () { var over = body.scrollHeight > body.clientHeight + 4; c.classList.toggle('is-clamped', over); more.hidden = !over; };
		var det = c.closest('details');
		if (det) { det.addEventListener('toggle', check); }
		check();
		more.addEventListener('click', function () { c.classList.add('is-open'); c.classList.remove('is-clamped'); more.hidden = true; });
	});

	/* -------------------------------------------------------------- rails */
	$$('[data-rail]').forEach(function (rail) {
		var track = $('.rail__track', rail), prev = $('.rail__btn--prev', rail), next = $('.rail__btn--next', rail);
		if (!track) { return; }
		var sync = function () {
			if (prev) { prev.disabled = track.scrollLeft < 8; }
			if (next) { next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8; }
		};
		[prev, next].forEach(function (b) {
			if (b) { b.addEventListener('click', function () { track.scrollBy({ left: (+b.getAttribute('data-dir')) * track.clientWidth * 0.9, behavior: 'smooth' }); }); }
		});
		track.addEventListener('scroll', debounce(sync, 50), { passive: true });
		sync();
	});
})();
